import React from "react";
import "./ExploreBtn.css";

const ExploreBtn = ({ text, onClick, type = "type" }) => {
  return (
    <button className="explore-btn" type={type} onClick={onClick}>
      {text}
    </button>
  );
};

export default ExploreBtn;
